import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-46dc64fc")
const _hoisted_1 = {
  key: 0,
  class: "_label"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "display"
}
const _hoisted_4 = { class: "del" }
const _hoisted_5 = { class: "i" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "del" }
const _hoisted_8 = { class: "i" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = {
  key: 1,
  class: "uploadBar"
}
const _hoisted_11 = {
  key: 0,
  class: "t"
}
const _hoisted_12 = {
  key: 1,
  class: "t e"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "File not accepted", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "t e"
}
const _hoisted_16 = {
  key: 2,
  class: "uploadBar"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "t e" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Ready")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  class: /*#__PURE__*/_normalizeClass({prompt:true,})
}
const _hoisted_20 = ["accept", "readonly", "multiple"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.label || _ctx.limit)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.limit)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.length) + "/" + _toDisplayString(_ctx.limit) + ")", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({
    fileUploader:true,
    large: _ctx.large,
    colored: _ctx.colored,
    white: _ctx.white,
    readonly: _ctx.readonly,
    icon: _ctx.icon,
    files:(_ctx.newFiles && _ctx.newFiles.length) || (_ctx.files && _ctx.files.length)
  })
    }, [
      ((_ctx.files && _ctx.files.length) || (_ctx.newFiles && _ctx.newFiles.length))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.files && _ctx.files.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.files, (file, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "file",
                    key: file.name
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_IconButton, {
                          icon: "download",
                          white: true,
                          onClick: ($event: any) => (_ctx.downloadFile(index))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_IconButton, {
                          icon: "cross",
                          white: true,
                          onClick: ($event: any) => (_ctx.deleteFile(index))
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    (file.location)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass({
            _img:true,
            filetype:true
          }),
                          style: _normalizeStyle(`background-image: url(${file.location}); background-size: cover`)
                        }, [
                          _createVNode(_component_MovingIcon, {
                            name: 
              file.type == 'psd'?'psd'
              :file.type.startsWith('doc')?'docx'
              :file.type.startsWith('ppt')?'pptx'
              :file.type.startsWith('json')?'json'
              :file.type.startsWith('pdf')?'pdf'
              :file.type.startsWith('html')?'html'
              :''
            ,
                            type: "svg"
                          }, null, 8, ["name"])
                        ], 4))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(file.name), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (_ctx.newFiles && _ctx.newFiles.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.newFiles, (file, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "file",
                    key: file.name
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_IconButton, {
                          icon: "cross",
                          white: true,
                          onClick: ($event: any) => (_ctx.removeFile(index))
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    (file.preview)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass({
            _img:true,
            filetype:true
          }),
                          style: _normalizeStyle(`background-image: url(${file.preview}); background-size: cover`)
                        }, [
                          _createVNode(_component_MovingIcon, {
                            name: 
              file.type == 'psd'?'psd'
              :file.type.startsWith('doc')?'docx'
              :file.type.startsWith('ppt')?'pptx'
              :file.type.startsWith('json')?'json'
              :file.type.startsWith('pdf')?'pdf'
              :file.type.startsWith('html')?'html'
              :''
            ,
                            type: "svg"
                          }, null, 8, ["name"])
                        ], 4))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(file.name), 1),
                    (file.uploadPerc)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (file.uploadPerc < 100)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_MovingIcon, {
                                  name: "upload",
                                  autoplay: true,
                                  loop: true,
                                  hex: "#FFFFFF"
                                }),
                                _createElementVNode("div", null, _toDisplayString(file.uploadPerc) + "%", 1)
                              ]))
                            : (file.uploadError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_MovingIcon, {
                                    name: "tick",
                                    type: "svg",
                                    hex: "#FFFFFF"
                                  })
                                ])),
                          _createElementVNode("div", {
                            class: "bar",
                            style: _normalizeStyle(`width: ${file.uploadPerc}%`)
                          }, null, 4)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_IconButton, {
          icon: !_ctx.newFiles.length?`upload`:``,
          text: _ctx.newFiles.length?_ctx.multiple?`Add files`:`Change file`:_ctx.multiple?`Select files`:`Select file`,
          onClick: _ctx.selectFile
        }, null, 8, ["icon", "text", "onClick"]),
        (_ctx.newFiles.length)
          ? (_openBlock(), _createBlock(_component_IconButton, {
              key: 0,
              icon: "upload",
              text: "Upload",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadAll()))
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("input", {
        ref: "input",
        type: "file",
        accept: _ctx.acceptedTypes,
        readonly: _ctx.readonly,
        multiple: _ctx.multiple,
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fileChosen && _ctx.fileChosen(...args)))
      }, null, 40, _hoisted_20)
    ], 2)
  ], 64))
}